import CustomErrorBoundary from './CustomErrorBoundary';

export default CustomErrorBoundary;
